import getters from './getters'
import mutations from './mutations'
import actions from './actions'

export const marketRecord = {
  namespaced: true,
  state: {
    marketRecords: []
  },
  getters,
  mutations,
  actions
};

